module.exports = __webpack_public_path__ + "static/first_choice_good_to_go-5e434abbe55626acc6938cf01a9285cb.jpg";